import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash-es';

import * as s from '../styles';
import type { IKlaviyoStatusIndicator } from '../types';


export const StaticKlaviyoStatusIndicator = ({
  indicator = null,
  status = null,
  ...props
}: IKlaviyoStatusIndicator) => {
  const { t } = useTranslation();
  const hiddenText = 'View details about Klaviyo’s status: ';

  if (!status) return null;

  return (
    <s.StyledKlaviyoStatusIndicator {...props}>
      <s.IndicatorLink aria-label={`${hiddenText}${status} (opens in a new tab)`} href="https://status.klaviyo.com" rel="noreferrer" target="_blank">
        <s.Indicator $indicator={indicator} />
        <s.StatusText colorVariant="light" variant="paragraph1Semibold">
          <s.HiddenText>{hiddenText}</s.HiddenText>
          {t(`organisms_klaviyoStatusIndicator_status_${camelCase(status)}`, '')}
        </s.StatusText>
      </s.IndicatorLink>
    </s.StyledKlaviyoStatusIndicator>
  );
};

export default StaticKlaviyoStatusIndicator;
